import classNames from "classnames";
import React from "react";
import { compareLanguages } from "utilities/translationUtils";

interface Props {
  article: server.dto.Article;
  selectedLanguage: server.dto.Languages;
  allLanguages: server.dto.Language[];
  onLanguageClicked: (newLanguage: server.dto.Languages) => void
}

const LanguagesMenu = ({ article, allLanguages, selectedLanguage, onLanguageClicked }: Props) => {
  const sortedLanguages = [...allLanguages].sort((a, b) => compareLanguages(a.value, b.value));

  const getLanguageClassNames = (language: server.dto.Languages) => classNames("padding", {
    "selected": language === selectedLanguage,
    "noexist": !article.translations.some(t => t.language === language)
  })
  return <div className="languagemenu">
    {sortedLanguages.map(lang => (
      <div key={lang.value} className={getLanguageClassNames(lang.value)} onClick={() => onLanguageClicked(lang.value)}>
        {lang.nativeName}
      </div>
    ))}
  </div>
}

export default LanguagesMenu;